<template>
    <div class="ProfileDropdown">
        <div class="ProfileDropdown__info">
            <div class="ProfileDropdown__header">
                <img
                    v-if="userProfile.profile_image"
                    class="ProfileDropdown__avatar-image"
                    :src="userProfile.profile_image"
                    alt="avatar"
                >
                <div
                    v-else
                    class="ProfileDropdown__avatar-container"
                >
                    <StreamlineIcon
                        class="ProfileDropdown__avatar-icon"
                        :icon="SingleNeutral"
                        :size="12"
                        stroke="white"
                    />
                </div>
                <span class="ProfileDropdown__name">{{ userProfile.first_name }}</span>
            </div>
            <span class="ProfileDropdown__role">{{ userProfile.role_name }}</span>
            <span class="ProfileDropdown__email">{{ userProfile.email }}</span>
        </div>
        <div class="ProfileDropdown__actions">
            <div
                class="ProfileDropdown__profile-link"
                @click="e => $emit('nav-to-profile', e)"
            >
                Manage Profile
            </div>
            <div
                class="ProfileDropdown__sign-out"
                @click="e => $emit('sign-out', e)"
            >
                <StreamlineIcon
                    class="ProfileDropdown__sign-out-icon"
                    :icon="PowerButton"
                    :fill="textGrey"
                    :size="16"
                />
                <span class="ProfileDropdown__sign-out-text">Sign out</span>
            </div>
        </div>
    </div>
</template>
<script>
import {SingleNeutral} from '@reviewpush/streamline-regular/lib/users/GeomerticCloseUpSingleUserNeutral';
import {PowerButton} from "@reviewpush/streamline-bold/lib/interface-essential/OnOff";
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {textGrey} from 'style/_colors.scss';

export default {
    name: 'ProfileDropdown',
    components: {
        StreamlineIcon,
    },
    props: {
        userProfile: {
            type: Object,
            required: true,
        }
    },
    data(){
        return {
            SingleNeutral,
            PowerButton,
            textGrey
        };
    }

};
</script>
<style lang="scss">
    .ProfileDropdown {
        border: 1px solid $grey-100;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
        background: $white;
        border-radius: 4px;
        color: $text-dark;

        &__info,
        &__actions {
            padding: 1rem;
            border-bottom: 1px solid $grey-100;
            display: flex;
            flex-direction: column;
        }

        &__header,
        &__role {
            margin-bottom: 0.25rem;
        }
        &__header {
            font-weight: 600;
            color: $text-dark;
            display: flex;
            align-items: center;
        }
        &__role,
        &__email {
            font-size: 0.8rem;
        }
        &__email {
            color: $text-grey;
        }

        &__avatar-container {
            height: 1rem;
            width: 1rem;
            border-radius: 90%;
            background: $grey;
            display:inline-block;
            text-align: center;
            margin-right: 0.25rem;
        }
        &__avatar-container {
            height: 1rem;
            width: 1rem;
            border-radius: 90%;
            margin-right: 0.25rem;
        }
        &__avatar-icon {
            height: 0.75rem;
            width: 0.75rem;
        }

        &__actions {
            color: $text-grey;
        }
        &__profile-link {
            cursor: pointer;
            color: $text-grey;
            margin-bottom: 0.5rem;
        }

        &__sign-out {
            display: flex;
            align-items: center;
        }
        &__sign-out-icon {
            margin-right: 0.5rem;
        }

    }
</style>
